import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/i18n/I18nContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

// Blocks a client from using the app until they provide their cédula/passport (mandatory for invoicing).
export function DocumentGate() {
  const { user, refreshUser } = useAuth();
  const { tl } = useI18n();
  const [idType, setIdType] = useState("cedula");
  const [idNumber, setIdNumber] = useState("");
  const [busy, setBusy] = useState(false);

  const needs = user && user.role === "client" && !user.id_number;
  if (!needs) return null;

  const save = async (e) => {
    e.preventDefault();
    if (!idNumber.trim()) return;
    setBusy(true);
    try {
      await api.put("/me/profile", { id_type: idType, id_number: idNumber.trim() });
      await refreshUser();
      toast.success(tl({ es: "Documento guardado", en: "Document saved", fr: "Document enregistré" }));
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
      setBusy(false);
    }
  };

  return (
    <Dialog open={true}>
      <DialogContent data-testid="document-gate"
        onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle>{tl({ es: "Completa tu documento", en: "Complete your document", fr: "Complète ton document" })}</DialogTitle>
          <DialogDescription>
            {tl({
              es: "Necesitamos tu cédula o pasaporte para poder emitir tus facturas. Es obligatorio para continuar.",
              en: "We need your ID or passport to issue your invoices. It's required to continue.",
              fr: "Nous avons besoin de ta cédula ou passeport pour émettre tes factures. C'est obligatoire pour continuer.",
            })}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={save} className="space-y-3">
          <div className="grid grid-cols-3 gap-2">
            <select data-testid="gate-id-type" value={idType} onChange={(e) => setIdType(e.target.value)}
              className="col-span-1 h-11 rounded-lg border border-border bg-background px-2 text-sm">
              <option value="cedula">Cédula</option>
              <option value="ruc">RUC</option>
              <option value="pasaporte">{tl({ es: "Pasaporte", en: "Passport", fr: "Passeport" })}</option>
            </select>
            <Input data-testid="gate-id-number" required value={idNumber} onChange={(e) => setIdNumber(e.target.value)}
              placeholder={tl({ es: "N° de documento", en: "Document no.", fr: "N° de document" })} className="col-span-2 h-11" />
          </div>
          <Button type="submit" data-testid="gate-save" disabled={busy} className="w-full rounded-full">
            {tl({ es: "Guardar", en: "Save", fr: "Enregistrer" })}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
